import { SizeXxsIcon } from './SizeXxsIcon';

/**
 * author: Austin Andrews
 * id 97AAC6A1-8F86-49CD-AAE2-3F9CFDDCBD82
 * name size-xxs
 * version: 5.0.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/size-xxs.svg
 * tags
 */
export const SizeExtraExtraSmallIcon = SizeXxsIcon;
export default SizeExtraExtraSmallIcon